import { Manager } from './core/Manager';
import { GameScene } from './scene/GameScene';

(async () => {
    await Manager.initialize("#000000");

    console.log("after initialize");

    const game = new GameScene();
    await Manager.changeScene(game, true);

})();